// extracted by mini-css-extract-plugin
export var currencyInput = "_nm-1";
export var currencySymbol = "_nm-0";